var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"no-location"},[_c('div',[_c('p',[_vm._v("There are no locations, please ")]),_c('button',{staticClass:"button is-white",on:{"click":function($event){return _vm.handleAddLocation()}}},[_vm._v(" create location ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }